export enum SegmentType {
    B2b = 'b2b',
    B2c = 'b2c',
}
